import Vue from 'vue';
import { _api } from '@/utils/apiAxios';
import router from '@/router';

// import {socketHelper} from "../../../utils/signalR"
const socket = require('@/utils/signalR').socket;
import get from 'lodash/get';
import { getField, updateField } from 'vuex-map-fields';
import { updateBetLineOdds, updateBetLineOutcome } from './socket-utils';
import { linesHelper } from '@/utils/linesHelper';
import { log } from '@/utils/logging';
import { flatten, sleep } from '@/utils/common';
import { scrollToLineItem, smoothScroll } from '@/views/sports/store/bet-line-utils';
import { isElectronContext } from '../../../utils/isElectron';
import snq from 'snq';
const isElectron = isElectronContext() || typeof Epos_Android_Interface != 'undefined';

let firstRequest = false;
let isTryToConnect = false;
let tryConnectInterval;
let isTryToGetChanges;
const state = function () {
  return {
    marketFirstChanged: false,
    status: { loading: false },
    betLineItems: [],
    favLines: [],
    showStatsModal: false,
    statsGameData: {},
    sportGroup: [],
    allsportGroup: [],
    liveActiveTab: {},
    showFav: false,
    eventId: null,
    showStatsModalIframe: false,
    selectedMarketsMap: {},
    betLineLiveItems: [],
    browserIsIdle: false,
    toScrollItem: {
      type: null,
      id: null,
    },
    isLinesLoading: false,
    mostPlayedGames: [],
    mostPlayedGamesLoading: false,
    marketRequestLoading: false,
  };
};
const getters = {
  getField,
  visitingTeamAbbr: state => get(state.statsGameData.originalResponse, 'visiting-team.team-name.@attributes.alias'),
  homeTeamAbbr: state => get(state.statsGameData.originalResponse, 'home-team.team-name.@attributes.alias'),
  getGameIds: state =>
    flatten(state.betLineItems.map(header => header.dates.map(date => date.games.map(line => line.id)))),
};
const mutations = {
  marketChanged: state => {
    state.marketFirstChanged = true;
  },
  setToScrollItem: (state, { type, id }) => {
    state.toScrollItem = { type, id };
  },
  updateField,
  initializing: state => {
    state.status = { loading: true };
  },
  setMarketRequestLoading: (state, val) => {
    state.marketRequestLoading = val;
  },
  requestSuccess: (state, data) => {
    state.status = { loading: false };
    // MAKE UPPERCASE TEAM NAMES
    // if (data && data.length) {
    //   data = data.map((d) => {
    //     d.games = (d.games || []).map((line) => {
    //       line.visitorTeam = line.visitorTeam.toUpperCase();
    //       line.homeTeam = line.homeTeam.toUpperCase();
    //       return line;
    //     });
    //     return d;
    //   });
    // }
    state.betLineItems = data;
  },
  requestEnded: state => {
    state.status = { loading: false };
  },
  clearFavBetLines: state => {
    state.favLines = [];
  },
  setShowStatsModal: (state, value) => {
    if (value.sport_type) {
      state.showStatsModal = true;
      state.statsGameData = value;
    } else {
      state.showStatsModal = false;
    }
  },
  setShowStatsModalIframe: (state, value) => {
    if (value) {
      state.showStatsModalIframe = true;
      state.eventId = value;
    } else {
      state.showStatsModalIframe = false;
    }
  },
  setLiveActiveTab: (state, value) => {
    state.liveActiveTab = value;
  },
  setAllSportGroup: (state, list) => {
    let leagueList = [];
    list.map(item => {
      leagueList.push({
        league_id: item.tournamentId,
        count: item.dates.length,
        line_list: item.dates,
        title: item.sport,
        icon: 'soccer-ball',
      });
    });
    state.allsportGroup = leagueList;
  },
  setSportGroup: (state, list) => {
    state.sportGroup = [];

    let leagueList = [];
    leagueList = list.map(item => {
      return {
        league_id: item.tournamentId,
        count: item.dates.length,
        line_list: item.dates,
        title: item.sport,
        icon: 'soccer-ball',
      };
    });

    if (state.liveActiveTab.icon === 'all-sport') {
      state.allsportGroup = leagueList;
    }

    state.sportGroup = leagueList;
  },
  hideFavorites(state) {
    state.showFav = false;
  },
  updateBetLines: (state, data) => {
    state.betLineItems = data;
  },
  addSelectedMarket: (state, { line, market, isFavLine }) => {
    state.selectedMarketsMap[line.tournamentId + '_' + isFavLine] = market;
  },
  removeSelectedMarket: (state, line, isFavLine) => {
    delete state.selectedMarketsMap[line.tournamentId + '_' + isFavLine];
  },
  clearSelectedMarkets: state => {
    state.selectedMarketsMap = {};
  },
  setBrowserIsIdle(state, val) {
    state.browserIsIdle = val;
  },
  setIsLinesLoading(state, val) {
    state.isLinesLoading = val;
  },
  setMostPlayedGames(state, value) {
    state.mostPlayedGames = value;
  },
  setMostPlayedGamesLoading(state, value) {
    state.mostPlayedGamesLoading = value;
  },
};
const actions = {
  async getMostPlayedGames({ rootState, commit }, leagueId) {
    try {
      if (isElectron || rootState.sportMenu.activeMenu.icon === 'live') {
        return;
      }

      commit('setMostPlayedGamesLoading', true);
      const response = await _api.post('game/gamelistbymostplayed', {
        leagues: leagueId,
        line_style: rootState.settings.selectedOddType,
        language_id: rootState.settings.selectedLocale.id,
        utc: rootState.settings.timeZone.code,
        isLogged: !!isElectron || !!rootState.player.isLogged,
      });

      if (response.data.IsSuccess) {
        const mostPlayedGames = response.data.Data;

        const sortedMostPlayedGames = mostPlayedGames.sort(
          (a, b) => new Date(a.gameDate).valueOf() - new Date(b.gameDate).valueOf(),
        );

        commit('setMostPlayedGames', sortedMostPlayedGames);
      } else {
        commit('setMostPlayedGames', []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      commit('setMostPlayedGamesLoading', false);
    }
  },

  async getLinesByLeagueId({ rootState, state, commit }, leagueId) {
    // sleep added because wait for player selectedOddType config from api.
    // TODO: find actual solution and remove this if:
    if (!firstRequest) {
      await sleep(1000);
      firstRequest = true;
    }
    return _api.post('/game/getGamesByLeagueWithOdds', {
      tournamentId: leagueId,
      isLive: rootState.sportMenu.activeMenu.icon === 'live',
      providerId: 1,
      idLanguage: rootState.settings.selectedLocale.id,
      utc: rootState.settings.timeZone.code,
      lineStyle: rootState.settings.selectedOddType,
      isLogged: !!isElectron || !!rootState.player.isLogged,
    });
    return _api.post('/game/gamelistbyleagueid', {
      leagues: leagueId,
      line_style: rootState.settings.selectedOddType,
      language_id: rootState.settings.selectedLocale.id,
      utc: rootState.settings.timeZone.code,
      isLogged: !!isElectron || !!rootState.player.isLogged,
    });
  },
  getLinesForLiveCount: ({ commit, dispatch }, leagueId) => {
    if (!leagueId) {
      return;
    }
    leagueId = leagueId.replace('null,', '');
    if (state.isLinesLoading) {
      return;
    }

    commit('setIsLinesLoading', true);

    dispatch('getLinesByLeagueId', leagueId).then(res => {
      if (res.data.IsSuccess) {
        const list = res.data.Data ? res.data.Data : [];
        commit('setAllSportGroup', list);
      }
      commit('setIsLinesLoading', false);
    });
  },
  getBetLines: ({ commit, dispatch, state }, leagueId) => {
    // log("[BETLINES] get bet lines for league: " + leagueId);
    if (!leagueId) {
      console.log('[getBetLines] leagueId doesnt exists');
      //commit('requestSuccess', []);
      return;
    }

    if (state.status.loading) {
      console.log('[getBetLines] loading');
      return;
    }
    commit('initializing');
    leagueId = leagueId.replace('null,', '');

    dispatch('getMostPlayedGames', leagueId);

    dispatch('getLinesByLeagueId', leagueId)
      .then(res => {
        console.log('REST:' + res);
        if (res.data.IsSuccess) {
          commit('requestEnded');
          const list = res.data.Data ? res.data.Data : [];
          list.forEach(f =>
            f.dates.forEach(d => {
              d.show = d.show || true;
            }),
          );
          commit('requestSuccess', list);
          commit('setSportGroup', list);
          dispatch('connectSocket', 'updateOdds');
          dispatch('betSlip/checkAndCompareLines', list, { root: true });

          const toScrollItem = state.toScrollItem;

          if (toScrollItem && toScrollItem.id) {
            scrollToLineItem(toScrollItem);
          }
        } else {
          commit('requestSuccess', []);
        }
      })
      .finally(() => {
        dispatch('setLiveScoreGames');
        commit('requestEnded');
      });
  },
  getLinesChanges: ({ commit, state, dispatch, rootState }, leagueId) => {
    log('[BETLINES] get line changes for league: ' + leagueId);
    if (rootState.freeWagerStore.freeWagersViewing) {
      dispatch('freeWagerStore/tryGetFreeWagerLines', null, { root: true });
      return;
    }

    if (!leagueId) {
      commit('requestSuccess', []);
      return;
    }
    if (isTryToGetChanges) return;
    isTryToGetChanges = true;
    if (state.isLinesLoading) {
      return;
    }

    commit('setIsLinesLoading', true);

    dispatch('getLinesByLeagueId', leagueId)
      .then(res => {
        if (res.data.IsSuccess) {
          const list = res.data.Data ? res.data.Data : [];
          commit('requestSuccess', list);
          commit('setSportGroup', list);
          list.forEach(f =>
            f.dates.forEach(d => {
              d.show = d.show || true;
            }),
          );
          dispatch('connectSocket', 'updateOdds');
          dispatch('betSlip/checkAndCompareLines', list, { root: true });
        }
      })
      .finally(() => {
        dispatch('setLiveScoreGames');
        commit('requestEnded');
        commit('setIsLinesLoading', false);
        isTryToGetChanges = false;
      });
  },
  addFavLines: ({ commit, dispatch }, data) => {
    dispatch('addBetLines', data);
  },
  addBetLines: ({ dispatch, rootState }, data) => {
    let isAdded = false;
    let game = data.item;
    let line = JSON.parse(JSON.stringify(data.line));
    let isExistSportType = rootState.betLines.favLines.some((sport) => line.tournamentId === sport.tournamentId);
    const activeMenuIcon = rootState.sportMenu.activeMenu.icon;
    if (!isExistSportType) {
      let allGames = [];
      line.dates = line.dates.map(item => {
        item.games = item.games.filter(gItem => game.id === gItem.id);
        if (item.games.length > 0) {
          return item;
        }
      });
      line.dates = line.dates.filter(d => d);
      // rootState.betLines.betLineItems
      //   .find((sport) => line.tournamentId === sport.tournamentId)
      //   .dates
      //   .forEach((item) => {
      //     if (item.games.find(gItem => gItem.id === game.id)) {
      //       item.games = item.games;
      //       allGames.push(item);
      //     }
      //     allGames.push();
      //   });
      // line.dates = [];
      // allGames = allGames.map((a) => ({ ...a, icon: activeMenuIcon }));

      // line.dates.push(...allGames);
      rootState.betLines.favLines.push(line);
      isAdded = true;
    } else {
      const isExist = rootState.betLines.favLines
        .find((sport) => line.tournamentId === sport.tournamentId)
        .dates.some((item) => item.games.some(g => g.id === game.id));
      if (isExist) {
        //Delete exist fav
        let selectedFavLine = rootState.betLines.favLines.find(
          (sport) => line.tournamentId === sport.tournamentId,
        );
        let newDates = [];
        selectedFavLine.dates.forEach(d => {
          d.games = d.games.filter(g => g.id !== game.id);
        });
        selectedFavLine.dates = selectedFavLine.dates.filter(d => d.games.length > 0);
        //Delete Blank sport-league favs
        if (
          !rootState.betLines.favLines.find((sport) => line.sport_league_id === sport.sport_league_id).line_list.length
        ) {
          rootState.betLines.favLines = rootState.betLines.favLines.filter(
            (sport) => line.sport_league_id !== sport.sport_league_id,
          );
        }
      } else {
        isAdded = true;
        //findAllGroupIdLines
        let allGames = rootState.betLines.betLineItems
          .find((sport) => line.tournamentId === sport.tournamentId)
          .dates
          .forEach(d => {
            if (rootState.betLines.favLines.find((sport) => line.tournamentId === sport.tournamentId)) {
              if (rootState.betLines.favLines
                .find((sport) => line.tournamentId === sport.tournamentId)
                .dates
                .find(df => df.date == d.date)) {
                rootState.betLines.favLines
                  .find((sport) => line.tournamentId === sport.tournamentId)
                  .dates
                  .find(df => df.date == d.date)
                  .games.push(game);
              }
            }
          });
        // rootState.betLines.favLines
        //   .find((sport) => line.tournamentId === sport.tournamentId)
        //   .line_list.push(...allGames);
      }
    }
    if (!rootState.betLines.selectedMarketsMap[line.title + '_' + true]) {
      rootState.betLines.selectedMarketsMap[line.title + '_' + true] =
        rootState.betLines.selectedMarketsMap[line.title + '_' + false];
    }
    if (
      isAdded &&
      rootState.betLines.selectedMarketsMap[line.title + '_' + true] &&
      rootState.betLines.selectedMarketsMap[line.title + '_' + true].description !==
      rootState.betLines.selectedMarketsMap[line.title + '_' + false].description
    ) {
      rootState.betLines.selectedMarketsMap[line.title + '_' + true] =
        rootState.betLines.selectedMarketsMap[line.title + '_' + false];
      dispatch('selectMarket', {
        market: rootState.betLines.selectedMarketsMap[line.title + '_' + true],
        line: rootState.betLines.favLines.find((sport) => line.tournamentId === sport.tournamentId),
        live: false,
        isFavLine: true,
        triggered: true,
      });
    }
  },
  clearFavLines: ({ commit }) => {
    commit('clearFavBetLines');
  },
  connectSocket: ({ commit, rootState, dispatch, state }) => {
    if (!rootState.settings.brandSettings.socket_is_active) return;
    if (state.browserIsIdle) return;
    if (socket.connectionStates.connected === rootState.settings.socketConnection) {
      clearInterval(tryConnectInterval);
      isTryToConnect = false;
      return;
    }

    log('[BETLINES] trying to connect socket');

    rootState.settings.socketConnection = socket.connectionStates.connecting;

    socket._signalR
      .connect(() => {
        rootState.settings.socketConnection = socket.connectionStates.disconnected;
        if (state.browserIsIdle) return;
        if (!isTryToConnect) {
          tryConnectInterval = setInterval(() => {
            if (
              router.currentRoute.matched &&
              router.currentRoute.matched.length &&
              router.currentRoute.matched[0].name === 'sports'
            ) {
              dispatch('getLinesChanges', rootState.sportMenu.activeLeagueId);
            }
          }, rootState.settings.brandSettings.socket_fail_interval);
          isTryToConnect = true;
        }
      })
      .then(res => {
        log('[BETLINES] socket connected');
        rootState.settings.socketConnection = socket.connectionStates.connected;
        // listen to spesific line type for odds changes
        // let gameIds = [];
        // let lmIds = [];
        // rootState.betLines.betLineItems.forEach(f => {
        //   f.dates.forEach(d => {
        //     d.games.forEach(g => {
        //       gameIds.push(g.id);
        //       if (g.GameMarketTypes) {
        //         if (g.GameMarketTypes.moneyLine) {
        //           if (!lmIds.includes(g.GameMarketTypes.moneyLine.lineMarketId))
        //             lmIds.push(g.GameMarketTypes.moneyLine.lineMarketId);
        //         }
        //         if (g.GameMarketTypes.spread) {
        //           if (!lmIds.includes(g.GameMarketTypes.spread.lineMarketId))
        //             lmIds.push(g.GameMarketTypes.spread.lineMarketId);
        //         }
        //         if (g.GameMarketTypes.total) {
        //           if (!lmIds.includes(g.GameMarketTypes.total.lineMarketId))
        //             lmIds.push(g.GameMarketTypes.total.lineMarketId);
        //         }
        //       }
        //     });
        //   });
        // });
        // var socketRequest = {
        //   lineTypeId: rootState.settings.terminalInfo.id_line_type.toString(),
        //   gameIds: gameIds.join(','),
        //   lineMarketIds: lmIds.join(',')
        // }
        // socket._signalR.invoke('SubscribeToLineTypeAndGameIdsAndLmIds', socketRequest);
        
        socket._signalR.invoke('SubscribeToLineType', rootState.settings.terminalInfo.id_line_type);

        socket._signalR.subscribe('newGameCreated', data => {
          const isSportsBook =
            router.currentRoute.matched &&
            router.currentRoute.matched.length &&
            router.currentRoute.matched[0].name === 'sports';

          const isProps = router.currentRoute.matched[0].name === 'sports.props';
          if (isSportsBook) {
            dispatch('listenNewGameCreated', data);
          }
        });

        socket._signalR.subscribe('updateOdds', args => {
          const isSportsBook =
            router.currentRoute.matched &&
            router.currentRoute.matched.length &&
            router.currentRoute.matched[0].name === 'sports';

          const isProps = router.currentRoute.matched[0].name === 'sports.props';
          if (isSportsBook || isProps) {
            dispatch('setSocketMethods', args);
          }
        });
        // var hasEndMatch = false;
        socket._signalR.subscribe('updateLiveScore', args => {
          const isSportsBook =
            router.currentRoute.matched &&
            router.currentRoute.matched.length &&
            router.currentRoute.matched[0].name === 'sports';

          if (isSportsBook && args) {
            dispatch('setLiveScoreData', args);
            dispatch('propsStore/setScoreData', args, { root: true });
          }
        });
      })
      .catch(e => {
        if (!isTryToConnect) {
          rootState.settings.socketConnection = socket.connectionStates.disconnected;
          tryConnectInterval = setInterval(() => {
            const isSportsBook =
              router.currentRoute.matched &&
              router.currentRoute.matched.length &&
              router.currentRoute.matched[0].name === 'sports';

            const isProps = router.currentRoute.matched[0].name === 'sports.props';
            if (isSportsBook) {
              dispatch('getLinesChanges', rootState.sportMenu.activeLeagueId);
            }
          }, rootState.settings.brandSettings.socket_fail_interval);
          isTryToConnect = true;
          log('[BETLINES] socket connect failed');
        }
      });
  },
  listenNewGameCreated: ({ rootState, dispatch, commit, getters }, data) => {
    console.log('--listenNewGameCreated--', data);

    const gameIdsAtState = getters.getGameIds;

    if (!data) {
      return;
    }

    const IdLeague = snq(() => data.idLeague.toString());
    const IdGame = snq(() => data.idGame.toString());

    let currentMenu = rootState.sportMenu.menuList;
    if (rootState.sportMenu.activeMenu.icon !== 'live') {
      const activeLeagueId = rootState.sportMenu.activeLeagueId;
      if (activeLeagueId === IdLeague) {
        dispatch('getLinesChanges', activeLeagueId);
      }
      if (data.GameStat == 'O') {
        dispatch('sportMenu/updateMenu', '', { root: true });
      }
    } else {
      dispatch('sportMenu/updateMenu', '', { root: true });
      let liveMatches = linesHelper.getAllLeagueIds(currentMenu, rootState.sportMenu.activeMenu);
      // dispatch('betLines/getLinesForLiveCount', liveMatches, { root: true });
      if (rootState.sportMenu.activeNav.icon !== 'all-sport') {
        var isActiveLeague = rootState.sportMenu.activeNav.children.find(f => f.league_id == IdLeague);
        if (isActiveLeague) {
          let currentLeagueIds = linesHelper.getAllLeagueIds(currentMenu, rootState.sportMenu.activeNav);
          commit('sportMenu/setActiveLeague', currentLeagueIds, { root: true });
          if (!gameIdsAtState.find(id => id === IdGame)) {
            dispatch('betLines/getLinesChanges', currentLeagueIds, {
              root: true,
            });
          }
        }
      } else {
        commit('sportMenu/setActiveLeague', liveMatches, { root: true });
        if (!gameIdsAtState.find(id => id === IdGame)) {
          dispatch('betLines/getLinesChanges', liveMatches, { root: true });
        }
      }
    }
  },
  disconnectSocket: () => {
    log('[BETLINES] socket disconnect called');
    socket._signalR.disconnect();
  },
  setSocketMethods({ dispatch }, data) {
    // dispatch('removeGamesWithSocket', data);

    // data = data.filter((item) => item.s == 'O');
    // data = data.filter((item) => item.s != 'F');
    dispatch('setSocketData', data);
    dispatch('betSlip/setSocketData', data, { root: true });
    dispatch('propsStore/setSocketData', data, { root: true });
  },
  removeGamesWithSocket({ state }, data) {
    data.forEach(newItem => {
      /*
      oyun silme için mock data
      newItem.s = 'F';
      newItem.id = '10568798_1';
       */
      const itemInfo = newItem.id.split('_');
      const gameId = itemInfo[0];
      if (newItem.s != 'O') {
        //For Tabs Count
        // state.allsportGroup = state.allsportGroup.map((item) => {
        //   let line_list = item.line_list.filter((line) => {
        //     return !line || line.game_id_group != gameId;
        //   });
        //   return {
        //     ...item,
        //     line_list,
        //     count: line_list.length,
        //   };
        // });
        //for rendered matches
        // state.betLineItems = state.betLineItems.map((item) => {
        //   let line_list = item.line_list.filter((line) => {
        //     return !line || line.game_id_group != gameId;
        //   });
        //   return {
        //     ...item,
        //     line_list,
        //   };
        // });
        // state.mostPlayedGames = state.mostPlayedGames.filter((line) => {
        //   return !line || line.game_id_group != gameId;
        // });
      }
    });
  },
  setMostPlayedGamesOdds({ commit, state, rootState }, data) {
    const selectedOddType = rootState.settings.selectedOddType;
    const newMostPlayedGames = state.mostPlayedGames.map(line => {
      data.map(newItem => {
        if (!line || line.game_league_id != newItem.lid) return line;
        for (const key in line.odds) {
          const oddType = line.odds[key];
          if (!oddType) continue;
          if (key === 'special_money_lines') {
            const tournament = oddType.tournament;
            for (var i = 0; i < tournament.length; i++) {
              var odd = tournament[i];
              if (!odd || !odd.id) continue;
              if (odd.id === newItem.id) {
                // Match! update value
                updateBetLineOdds(odd, newItem.cov, newItem.csv, selectedOddType);
              }
            }
          } else {
            for (const subType in oddType) {
              const odd = oddType[subType];
              if (!odd || !odd.id) continue;
              if (odd.id === newItem.id) {
                // Match! update value
                updateBetLineOdds(odd, newItem.cov, newItem.csv, selectedOddType);
              }
            }
          }
        }
        return line;
      });
      return line;
    });
    commit('setMostPlayedGames', newMostPlayedGames);
  },
  setSocketData({ commit, rootState, state, dispatch }, data) {
    dispatch('setMostPlayedGamesOdds', data);
    let currentMenu = rootState.sportMenu.menuList;
    const selectedOddType = rootState.settings.selectedOddType;
    const activeLeagueIdArray = rootState.sportMenu.activeLeagueId ? rootState.sportMenu.activeLeagueId.split(',') : [];

    const selectedKeys = Object.keys(state.selectedMarketsMap);
    for (var key in selectedKeys) {
      const element = selectedKeys[key];
      if (element.league_id !== element.parent_league_id) {
        activeLeagueIdArray.push(element.league_id);
      }
    }
    //const allBetLineOddIds = getAllBetLineOddIds(state.betLineItems);
    let socketDataFilteredByLeagueId = [];
    // Socket Data Filtered By Showed LeagueId Array
    if (rootState.sportMenu.activeMenu.icon !== 'live') {
      socketDataFilteredByLeagueId = data.filter(item => activeLeagueIdArray.includes(item.lid));
      // if (socketDataFilteredByLeagueId.length === 0) return;
    } else {
      socketDataFilteredByLeagueId = data.filter(item =>
        linesHelper.getAllLeagueIds(currentMenu, rootState.sportMenu.activeMenu).includes(item.lid),
      );
      // if (socketDataFilteredByLeagueId.length === 0) return;
    }

    data.forEach(socketDat => {
      state.betLineItems.forEach(betLine => {
        betLine.dates.forEach(date => {
          date.games.forEach(game => {
            if (!game) return game;
            if (game.id != socketDat.ghid) return;
            Object.keys(game.GameMarketTypes).forEach(key => {
              if (!game.GameMarketTypes[key]) {
                return;
              }

              game.GameMarketTypes[key].gameMarketOutComes.forEach(outcome => {
                socketDat.omdl.forEach(socketOutcome => {
                  if (
                    (key == 'spread' || key == 'total') &&
                    socketOutcome.odd &&
                    socketDat.gmlmid == game.GameMarketTypes[key].lineMarketId
                  ) {
                    if (socketDat.fav && socketOutcome.opid == outcome.outcomeId) {
                      updateBetLineOutcome(
                        outcome,
                        socketOutcome.pts,
                        socketOutcome.odd,
                        selectedOddType,
                        key,
                        socketOutcome,
                        game.GameMarketTypes[key],
                        rootState.settings.selectedLocale.id,
                        false,
                      );
                    } else {
                      if (socketOutcome.oid == outcome.id) {
                        updateBetLineOdds(outcome, socketOutcome.pts, socketOutcome.odd, selectedOddType, key);
                      }
                    }
                  } else {
                    if (socketOutcome.oid == outcome.id) {
                      updateBetLineOdds(outcome, socketOutcome.pts, socketOutcome.odd, selectedOddType, key);
                    }
                  }
                });
              });
            });
          });
        });
      });
    });
  },
  setLiveScoreData({ commit, state, rootState }, data) {
    if (state.marketRequestLoading) {
      return;
    }

    let clonedBetLines = state.betLineItems.map(l => {
      l.dates = l.dates.map(date => {
        date.games = date.games
          .filter(g => g)
          .map(game => {
            if (game.providerId !== 1) return game;
            let gameBrId = game.providerEventId.split(':')[2];
            if (data.br_event_id != gameBrId) return game;
            let gameScore = data;
            if (gameScore) {
              if (
                (game.visitor_score && game.visitor_score != gameScore.away_score) ||
                (game.home_score && game.home_score != gameScore.home_score)
              ) {
                if (game.sport !== 'Basketball') Vue.set(game, 'changeScore', true);
              } else {
                Vue.set(game, 'changeScore', false);
              }
              if (game.period_scores) {
                if (game.period_scores.length === gameScore.period_scores.length) {
                  var lastPeriod = gameScore.period_scores[gameScore.period_scores.length - 1];
                  var lineLastPeriod = game.period_scores[game.period_scores.length - 1];
                  game.live_period = lastPeriod.number;
                  if (lastPeriod.home_score != lineLastPeriod.home_score) {
                    game.changePeriod = true;
                    game.change_home_period_score = true;
                  } else {
                    game.changePeriod = false;
                    game.change_home_period_score = false;
                  }
                  if (lineLastPeriod.away_score != lastPeriod.away_score) {
                    game.changePeriod = true;
                    game.change_visitor_period_score = true;
                  } else {
                    game.changePeriod = false;
                    game.change_visitor_period_score = false;
                  }
                  if (game.home_gamescore != gameScore.home_gamescore && gameScore.home_gamescore != 0) {
                    game.change_home_game_score = true;
                  } else {
                    game.change_home_game_score = false;
                  }
                  if (game.away_gamescore != gameScore.away_gamescore && gameScore.away_gamescore != 0) {
                    game.change_away_game_score = true;
                  } else {
                    game.change_away_game_score = false;
                  }
                }
              }

              game.visitor_score = data.away_score;
              game.home_score = data.home_score;
              game.period_scores = data.period_scores;
              game.away_gamescore = data.away_gamescore;
              game.home_gamescore = data.home_gamescore;
              game.deleteMe = data.game_status == 4 || data.game_status == 3;

              // Vue.set(game, 'away_score', gameScore.away_score);
              // Vue.set(game, 'home_score', gameScore.home_score);
              // Vue.set(game, 'period_scores', gameScore.period_scores);
              // Vue.set(game, 'away_gamescore', gameScore.away_gamescore);
              // Vue.set(game, 'home_gamescore', gameScore.home_gamescore);
              // Vue.set(game, 'home_gamescore', gameScore.home_gamescore);
              // Vue.set(game, 'change_home_game_score', game.change_home_game_score);
              // Vue.set(game, 'change_away_game_score', game.change_away_game_score);
              // Vue.set(game, 'change_home_period_score', game.change_home_period_score);
              // Vue.set(game, 'change_visitor_period_score', game.change_visitor_period_score);
              // Vue.set(game, 'deleteMe', gameScore.game_status === 4 || gameScore.game_status === 3);
            }
            if (!game.deleteMe) return game;
          });
        return date;
      });
      return l;
    });
    commit('updateBetLines', clonedBetLines);
    // const scoreMapper = (line) => {
    //   // Game was ended
    //   if (line.br_event_id) {
    //     if (line.br_event_id.includes(data.br_event_id)) {
    //       if (
    //         line.visitor_score !== data.away_score ||
    //         (line.home_score !== data.home_score && +data.home_score !== 0 && +data.visitor_score !== 0)
    //       ) {
    //         if (line.game_sport_type !== 'NBA') line.changeScore = true;
    //       }
    //       if (line.period_scores) {
    //         if (line.period_scores.length === data.period_scores.length) {
    //           var lastPeriod = data.period_scores[data.period_scores.length - 1];
    //           var lineLastPeriod = line.period_scores[line.period_scores.length - 1];
    //           line.live_period = lastPeriod.number;
    //           if (lastPeriod.home_score !== lineLastPeriod.home_score) {
    //             line.changePeriod = true;
    //             line.change_home_period_score = true;
    //           }
    //           if (lineLastPeriod.away_score !== lastPeriod.away_score) {
    //             line.changePeriod = true;
    //             line.change_visitor_period_score = true;
    //           }
    //           if (line.home_gamescore != data.home_gamescore && data.home_gamescore != 0) {
    //             line.change_home_game_score = true;
    //           }
    //           if (line.away_gamescore != data.away_gamescore && data.away_gamescore != 0) {
    //             line.change_away_game_score = true;
    //           }
    //         }
    //       }
    //       line.visitor_score = data.away_score;
    //       line.home_score = data.home_score;
    //       line.period_scores = data.period_scores;
    //       line.away_gamescore = data.away_gamescore;
    //       line.home_gamescore = data.home_gamescore;
    //       line.deleteMe = data.game_status === 4 || data.game_status === 3;
    //     }
    //   }

    //   return line;
    // };

    // const deleteMapper = (line) => {
    //   if (!line.deleteMe) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // };

    // let newBetLineItems1 = state.betLineItems.map((item) => {
    //   item.line_list = (item.line_list || []).map(scoreMapper);
    //   return item;
    // });

    // const newBetLineItems2 = newBetLineItems1.filter((item) => item.line_list.find(deleteMapper));
    // commit('updateBetLines', newBetLineItems2);

    // const filteredMostPlayedGames = state.mostPlayedGames.filter(deleteMapper);
    // commit('setMostPlayedGames', filteredMostPlayedGames);
  },
  openStatsModal: ({ commit }, game) => {
    const hasMatchup = game.game.has_matchup;
    const hasEventId = game.game.br_event_id;

    if (hasMatchup && !hasEventId) {
      commit('initializing');
      _api
        .post('/game/matchstats', {
          sport_type: game.game.game_sport_type,
          home_team: game.game.home_team,
          visitor_team: game.game.visitor_team,
          league_title: game.title,
        })
        .then(res => {
          if (res.data.IsSuccess) {
            const data = res.data.Data ? res.data.Data : null;
            commit('setShowStatsModal', data);
          }
        })
        .finally(() => {
          commit('requestEnded');
        });
    } else if (hasEventId) {
      let eventId = game.game.br_event_id;
      eventId = eventId.split(':')[2];
      commit('setShowStatsModalIframe', eventId);
    }
  },
  setLiveActiveTab: ({ commit, dispatch, rootState }, value) => {
    let league_ids = '';
    if (!value) {
      league_ids = '-1';
      dispatch('sportMenu/setActiveLeague', league_ids, { root: true });
      return;
    }
    if (!value.children) value.children = [];
    commit('setLiveActiveTab', value);
    rootState.sportMenu.activeNav = value;
    league_ids = value.children.map(item => item.league_id).join(',');
    if (value.icon === 'all-sport') {
      rootState.sportMenu.activeMenu.children.map(item => {
        // featured
        item.children.map(subItem => {
          // tabs
          subItem.children.map(league => {
            //leagues
            league_ids += league.league_id + ',';
          });
        });
      });
    }
    league_ids = league_ids
      .split(',')
      .filter(Boolean)
      .join(',');
    dispatch('sportMenu/setActiveLeague', league_ids, { root: true });
  },
  checkOdds: ({ state }, odds) => {
    let oddCount;
    if (odds.odds_view_count > 0) {
      oddCount = odds.odds_view_count;
      return oddCount;
    }
    const hasMoneyLines =
      !!odds.money_lines && ((!!odds.money_lines.home && !!odds.money_lines.visitor) || !!odds.money_lines.draw);
    const hasSpread = !!odds.spreads && ((!!odds.spreads.home && !!odds.spreads.visitor) || !!odds.spreads.draw);
    const hasTournament =
      !!odds.special_money_lines &&
      !!odds.special_money_lines.tournament &&
      !!odds.special_money_lines.tournament.length > 0;
    if (hasMoneyLines) {
      oddCount = 3;
    }
    if (hasMoneyLines && hasSpread) {
      oddCount = 6;
    }
    if (hasTournament) {
      oddCount = 1;
    }
    if (!hasMoneyLines && !hasSpread && !hasTournament) {
      oddCount = 0;
    }
    return oddCount;
  },
  selectMarket: ({ state, rootState, commit, dispatch }, { market, line, live, isFavLine, triggered }) => {
    !triggered ? commit('initializing') : false;
    commit('setMarketRequestLoading', true);
    _api
      .post('/game/getGamesByMarket', {
        tournamentId: line.tournamentId,
        isLive: live,
        lineStyle: rootState.settings.selectedOddType,
        idLanguage: rootState.settings.selectedLocale.id,
        lineMarketId: market.lineMarketId,
        utc: rootState.settings.timeZone.code,
      })
      .then(r => {
        if (r.data.IsSuccess) {
          if(r.data.Data[0].dates.length) {
            r.data.Data[0].dates.map(item=> {
              item.show =true          
            })
          }
          r.data.Data[0].dates
          const list = r.data.Data;
          const clonedBetLines = state.betLineItems.map(m => {
            list.forEach(f => {
              if (list && list.length > 0 && m.tournamentId == f.tournamentId) {
                m.dates = f.dates;
                m.sportViewType = f.sportViewType;
              }
            });
            return m;
          });
          if (document.getElementById('bg-dark')) {
            document.getElementById('bg-dark').remove();
          }
        
          commit('requestSuccess', clonedBetLines);

          // if (headers && headers.length > 0) {
          //   line.sport_type = headers[0].sport_type;
          //   line.line_list = headers[0].line_list
          //   line.header_date = headers[0].header_date
          //   line.header_date_time = headers[0].header_date_time
          //   line.date_list = headers[0].date_list
          //   if (document.getElementById('bg-dark')) {
          //     document.getElementById('bg-dark').remove();
          //   }
          // }

          // if(rootState.sportMenu.activeMenu.icon === 'live'){
          //     dispatch("setLiveScoreGames");
          // }
        }
        commit('requestEnded');
        commit('setMarketRequestLoading', false);
      });
  },
  setLiveScoreGames: ({ commit, state, rootState }) => {
    var list = state.betLineItems;
    var eventIds = [];

    if (rootState.sportMenu.activeMenu.icon === 'live') {
      list.forEach(l => {
        l.dates.forEach(date => {
          date.games.forEach(game => {
            if (!game.providerEventId) return;
            if (game.providerId === 1) eventIds.push(game.providerEventId.split(':')[2]);
          });
        });
      });
    }

    if (eventIds.length === 0) return;
    if (rootState.sportMenu.activeMenu.icon !== 'live') return;
    _api
      .get('/game/getlivescores?' + 'lang=' + rootState.settings.selectedLocale.id + '&brgameids=' + eventIds.join(','))
      .then(r => {
        if (r.data.IsSuccess) {
          const liveScores = r.data.Data;
          state.betLineItems.forEach(l => {
            l.dates.forEach(date => {
              date.games.forEach(game => {
                if (game.providerId == 1 && game.providerEventId) {
                  let gameBrId = game.providerEventId.split(':')[2];
                  let scoreGame = liveScores.find(f => f.br_event_id == gameBrId);
                  if (scoreGame) {
                    Vue.set(game, 'changeScore', false);
                    Vue.set(game, 'away_score', scoreGame.away_score);
                    Vue.set(game, 'home_score', scoreGame.home_score);
                    Vue.set(game, 'period_scores', scoreGame.period_scores);
                    Vue.set(game, 'home_gamescore', scoreGame.home_gamescore);
                    Vue.set(game, 'away_gamescore', scoreGame.away_gamescore);
                    Vue.set(game, 'deleteMe', scoreGame.game_status === 4 || scoreGame.game_status === 3);
                  }
                }
              });
            });
          });

          // commit('setMostPlayedGames', state.mostPlayedGames.map(scoreMapper));
          // commit('updateBetLines', newBetLineItems);
        }
      });
  },
};

function getOddIds(odds) {
  var ids = [];

  // moneylines
  if (odds.money_lines.home) ids.push(odds.money_lines.home.id);
  if (odds.money_lines.visitor) ids.push(odds.money_lines.visitor.id);
  if (odds.money_lines.draw) ids.push(odds.money_lines.draw.id);

  // spreads
  if (odds.spreads.home) ids.push(odds.spreads.home.id);
  if (odds.spreads.visitor) ids.push(odds.spreads.visitor.id);

  // totals
  if (odds.totals.under) ids.push(odds.totals.under.id);
  if (odds.totals.over) ids.push(odds.totals.over.id);

  //tournament
  if (odds.special_money_lines.tournament) ids.push(odds.special_money_lines.tournament.map(item => item.id));

  return ids;
}

function getAllBetLineOddIds(betLineItems) {
  let ids = [];
  betLineItems.forEach(item => {
    item.line_list.forEach(line => {
      ids.push(getOddIds(line.odds));
    });
  });
  return ids;
}

export const betLines = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
